function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createContext, useState, useRef } from 'react';
import { useFela } from 'react-fela';
import PropTypes from 'prop-types';
import { Block } from '../block';
import { Click } from '../click';
import { Arrow } from '../arrow';
import { Inline } from '../inline';
import { Flex } from '../flex';
import { getThemeStyle } from '../../get-theme-style';
export var TabNavContext = /*#__PURE__*/createContext({});
var styles = {
  nav: function nav(_ref) {
    var theme = _ref.theme,
        reverseOut = _ref.reverseOut;
    return {
      flexDirection: 'row',
      overflow: 'hidden',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderBottomColor: reverseOut ? theme.color.primitive.grey100 : theme.color.ornament.divider,
      backgroundColor: reverseOut ? theme.color.primitive.grey100 : theme.color.background.secondary
    };
  },
  scrollContainer: {
    flex: '0 1 auto',
    overflowY: 'hidden',
    overflowX: 'auto',
    msOverflowY: 'hidden',
    msOverflowX: 'auto',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  itemContainer: {
    flexDirection: 'row',
    padding: '0 0 0 19px'
  },
  stickyLeft: function stickyLeft(_ref2) {
    var isCentered = _ref2.isCentered;
    return {
      flexShrink: 0,
      flexBasis: 0,
      flexGrow: isCentered ? 1 : 0,
      msFlex: '1 0 auto',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    };
  },
  stickyRight: {
    flexShrink: 0,
    flexBasis: 0,
    flexGrow: 1,
    msFlex: '1 0 auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row'
  },
  border: function border(_ref3) {
    var reverseOut = _ref3.reverseOut,
        animatedMargin = _ref3.animatedMargin,
        duration = _ref3.duration,
        theme = _ref3.theme;
    return {
      width: 0,
      height: duration === 0 ? 0 : 3,
      marginRight: '0 !important',
      backgroundColor: reverseOut ? theme.color.primitive.white : theme.color.ornament.highlight,
      transitionProperty: "margin-".concat(animatedMargin, ", width"),
      transitionTimingFunction: 'ease-out',
      transitionDuration: duration + 'ms'
    };
  },
  backButton: function backButton(_ref4) {
    var _ref5;

    var reverseOut = _ref4.reverseOut,
        _ref4$showBackButtonO = _ref4.showBackButtonOn,
        showBackButtonOn = _ref4$showBackButtonO === void 0 ? [] : _ref4$showBackButtonO,
        theme = _ref4.theme;
    return _ref5 = {
      fontSize: 15,
      padding: '16px 10px 19px',
      verticalAlign: 'middle',
      fontWeight: 300,
      fontFamily: theme.fontTypes.NOVUM,
      whiteSpace: 'nowrap',
      flexShrink: '0',
      color: reverseOut ? theme.color.primitive.white : theme.color.foreground.primary,
      display: showBackButtonOn.some(function (size) {
        return size === 's';
      }) ? 'inline' : 'none',
      '> svg': {
        marginRight: 8
      },
      ':hover > svg': {
        transform: 'translateX(-5px)'
      }
    }, _defineProperty(_ref5, theme.breakpoints.onlyM, {
      display: showBackButtonOn.some(function (size) {
        return size === 'm';
      }) ? 'inline' : 'none'
    }), _defineProperty(_ref5, theme.breakpoints.fromL, {
      display: showBackButtonOn.some(function (size) {
        return size === 'l';
      }) ? 'inline' : 'none'
    }), _ref5;
  },
  backButtonText: function backButtonText(_ref6) {
    var theme = _ref6.theme;
    return _defineProperty({}, theme.breakpoints.onlyS, {
      display: 'none'
    });
  }
};

function BackButton(_ref8) {
  var _ref8$backButtonConfi = _ref8.backButtonConfig,
      backButtonConfig = _ref8$backButtonConfi === void 0 ? {} : _ref8$backButtonConfi,
      showBackButtonOn = _ref8.showBackButtonOn,
      reverseOut = _ref8.reverseOut;

  var _useFela = useFela(),
      theme = _useFela.theme;

  var href = backButtonConfig.href,
      _backButtonConfig$cli = backButtonConfig.clickHandler,
      clickHandler = _backButtonConfig$cli === void 0 ? function () {} : _backButtonConfig$cli,
      text = backButtonConfig.text;
  var styleProps = {
    theme: theme,
    reverseOut: reverseOut,
    showBackButtonOn: showBackButtonOn
  };
  return /*#__PURE__*/React.createElement(Click, {
    onClick: clickHandler,
    href: href,
    extend: [styles.backButton(styleProps), getThemeStyle('tabNavBackButton', theme, styleProps)]
  }, /*#__PURE__*/React.createElement(Arrow, {
    direction: "left",
    size: 10,
    color: reverseOut ? theme.color.primitive.white : theme.color.ornament.highlight
  }), /*#__PURE__*/React.createElement(Inline, {
    extend: styles.backButtonText
  }, text || ''));
}

function TabNavBorder() {
  var _React$useContext = React.useContext(TabNavContext),
      borderRef = _React$useContext.borderRef,
      reverseOut = _React$useContext.reverseOut,
      duration = _React$useContext.duration;

  var _useFela2 = useFela(),
      theme = _useFela2.theme;

  var animatedMargin = theme.direction === 'rtl' ? 'right' : 'left';
  return /*#__PURE__*/React.createElement(Block, {
    ref: borderRef,
    extend: styles.border({
      animatedMargin: animatedMargin,
      duration: duration,
      reverseOut: reverseOut,
      theme: theme
    })
  });
}

export var TabNav = /*#__PURE__*/React.forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
      _ref9$duration = _ref9.duration,
      duration = _ref9$duration === void 0 ? 160 : _ref9$duration,
      _ref9$enableLineTrans = _ref9.enableLineTransition,
      enableLineTransition = _ref9$enableLineTrans === void 0 ? false : _ref9$enableLineTrans,
      _ref9$textAlign = _ref9.textAlign,
      textAlign = _ref9$textAlign === void 0 ? 'center' : _ref9$textAlign,
      _ref9$stickyChildrenL = _ref9.stickyChildrenLeft,
      stickyChildrenLeft = _ref9$stickyChildrenL === void 0 ? null : _ref9$stickyChildrenL,
      _ref9$stickyChildrenR = _ref9.stickyChildrenRight,
      stickyChildrenRight = _ref9$stickyChildrenR === void 0 ? null : _ref9$stickyChildrenR,
      _ref9$showBackButtonO = _ref9.showBackButtonOn,
      showBackButtonOn = _ref9$showBackButtonO === void 0 ? ['s', 'm', 'l'] : _ref9$showBackButtonO,
      _ref9$backButton = _ref9.backButton,
      backButtonConfig = _ref9$backButton === void 0 ? {} : _ref9$backButton;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var scrollRef = useRef();
  var borderRef = useRef();

  var _useFela3 = useFela(),
      theme = _useFela3.theme;

  var isCentered = textAlign === 'center';
  var backButtonVisible = !!(backButtonConfig.clickHandler || backButtonConfig.href);
  var styleProps = {
    theme: theme,
    isCentered: isCentered
  };
  var context = {
    active: active,
    setActive: setActive,
    scrollRef: scrollRef,
    borderRef: borderRef,
    duration: enableLineTransition ? duration : 0
  };
  return /*#__PURE__*/React.createElement(Flex, {
    as: "nav",
    ref: ref,
    extend: [styles.nav(styleProps), getThemeStyle('tabNav', theme, styleProps)]
  }, /*#__PURE__*/React.createElement(Flex, {
    extend: styles.stickyLeft(styleProps)
  }, backButtonVisible ? /*#__PURE__*/React.createElement(BackButton, {
    backButtonConfig: backButtonConfig,
    showBackButtonOn: showBackButtonOn
  }) : null, stickyChildrenLeft), /*#__PURE__*/React.createElement(TabNavContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Flex, {
    ref: scrollRef,
    extend: styles.scrollContainer
  }, /*#__PURE__*/React.createElement(Flex, {
    extend: styles.itemContainer
  }, /*#__PURE__*/React.createElement(Flex, {
    extend: {
      paddingRight: 1
    }
  }), children, /*#__PURE__*/React.createElement(Flex, {
    extend: {
      paddingRight: 1
    }
  })), /*#__PURE__*/React.createElement(TabNavBorder, null))), /*#__PURE__*/React.createElement(Flex, {
    extend: styles.stickyRight
  }, stickyChildrenRight));
});
TabNav.displayName = 'TabNav';
TabNav.propTypes = {
  /** Text-align: left or center */
  textAlign: PropTypes.oneOf(['center', 'left']),

  /** Back button text, href, click handler */
  backButton: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    clickHandler: PropTypes.func
  }),

  /** A JSX node */
  children: PropTypes.node,

  /** A JSX node sticky to the left */
  stickyChildrenLeft: PropTypes.node,

  /** A JSX node sticky to the right */
  stickyChildrenRight: PropTypes.node,

  /** Which viewports to show the back button on */
  showBackButtonOn: PropTypes.arrayOf(PropTypes.oneOf(['s', 'm', 'l'])),

  /** Enable fancy transition when changing active tabs */
  enableLineTransition: PropTypes.bool,

  /** Set duration of lineTransition animation */
  duration: PropTypes.number
};